import styled from 'styled-components';
import tw from 'twin.macro';

export const Title = styled.label`
  ${tw`
    pt-2
  `};
`;
